/** @format */
import { useAppTranslation } from './../../../i18n/declarations';
import { TRoom } from '../declarations';

function nth(n: number) {
  return ['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th';
}

export const useRoomFeatures = ({ room }: { room: TRoom }) => {
  const { t } = useAppTranslation();
  const availableFeatures: string[] = [];

  if (room.building.buildingType !== 'Bed') return availableFeatures;
  if (room.flatFeatures.floor === 0) {
    const feature = t('card_flat_feature_ground_floor', { count: room.flatFeatures.floor });
    availableFeatures.push(feature);
  } else if (room.flatFeatures.floor) {
    const feature = t('card_flat_feature_floor', {
      suffix: nth(room.flatFeatures.floor),
      count: room.flatFeatures.floor,
    });
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.roomsCount && room.flatFeatures.roomsCount > 0) {
    if (room.flatFeatures.roomsCount === 1) {
      const feature = t('card_flat_feature_rooms_one_available', { count: room.flatFeatures.roomsCount });
      availableFeatures.push(feature);
    } else {
      const feature = t('card_flat_feature_rooms_available', { count: room.flatFeatures.roomsCount });
      availableFeatures.push(feature);
    }
  }
  if (room.flatFeatures.bathroomCount && room.flatFeatures.bathroomCount > 0) {
    if (room.flatFeatures.bathroomCount === 1) {
      const feature = t('card_flat_feature_bathrooms_one_available', { count: room.flatFeatures.bathroomCount });
      availableFeatures.push(feature);
    } else {
      const feature = t('card_flat_feature_bathrooms_available', { count: room.flatFeatures.bathroomCount });
      availableFeatures.push(feature);
    }
  }
  if (room.flatFeatures.airConditioning) {
    const feature = t('card_flat_feature_air_conditioning');
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.accessible) {
    const feature = t('card_flat_feature_accessible');
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.basement) {
    const feature = t('card_flat_feature_basement');
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.bikeParking) {
    const feature = t('card_flat_feature_bike_parking');
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.carParking) {
    const feature = t('card_flat_feature_car_parking');
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.conciergeServices) {
    const feature = t('card_flat_feature_consierge_services');
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.dishWasher) {
    const feature = t('card_flat_feature_dish_washer');
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.elevator) {
    const feature = t('card_flat_feature_elevator');
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.garden) {
    const feature = t('card_flat_feature_garden');
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.motorBikeParking) {
    const feature = t('card_flat_feature_motor_bike_parking');
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.pool) {
    const feature = t('card_flat_feature_pool');
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.television) {
    const feature = t('card_flat_feature_television');
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.terrace) {
    const feature = t('card_flat_feature_terrace');
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.washingMachine) {
    const feature = t('card_flat_feature_washing_machine');
    availableFeatures.push(feature);
  }
  if (room.flatFeatures.wiFi) {
    const feature = t('card_flat_feature_wifi');
    availableFeatures.push(feature);
  }
  if (room.roomFeatures.size) {
    const feature = t('card_flat_feature_size', { count: room.roomFeatures.size.toFixed(0) });
    availableFeatures.push(feature);
  }
  return availableFeatures.join(' • ');
};
